import { RootState } from "@/infrastructure/rootState";

export const isBtMetaLoading = ({ backtest }: RootState) => backtest.loading.meta === "REQUEST";
export const isTickerLoading = ({ backtest }: RootState) => backtest.loading.ticker === "REQUEST";
export const isBacktestLoading = ({ backtest }: RootState) => backtest.loading.backtest === "REQUEST";
export const isBacktestError = ({ backtest }: RootState) => backtest.loading.backtest === "FAILURE";
export const isBacktestSuccess = ({ backtest }: RootState) => backtest.loading.backtest === "SUCCESS";

export * from "./meta";
export * from "./setup";
export * from "./result";
